import { components } from "@/api-schema";
import { TemporaryPermissionStatus } from "@/api-schema-enums";
import { BadgeColor, BadgeSize, IconBadge } from "@/components/icon-badge/icon-badge";
import { AlertCircleIcon, CheckCircle2Icon, ClockIcon, XCircleIcon, type LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

type TemporaryPermissionStatusType = components["schemas"]["TemporaryPermission"]["status"];

const STATUS_CONFIG: Record<TemporaryPermissionStatus, { icon: LucideIcon; color: BadgeColor; tooltipKey: string }> = {
  [TemporaryPermissionStatus.Approved]: {
    icon: CheckCircle2Icon,
    color: BadgeColor.Success,
    tooltipKey: "ram:Approved",
  },
  [TemporaryPermissionStatus.Pending]: { icon: ClockIcon, color: BadgeColor.Warning, tooltipKey: "ram:Pending" },
  [TemporaryPermissionStatus.Rejected]: { icon: XCircleIcon, color: BadgeColor.Error, tooltipKey: "ram:Rejected" },
};

export function StatusCell({ status }: { status: TemporaryPermissionStatusType }) {
  const { t } = useTranslation(["ram"]);

  const config = status ? STATUS_CONFIG[status as TemporaryPermissionStatus] : undefined;

  if (!config) {
    return (
      <IconBadge
        icon={AlertCircleIcon}
        color={BadgeColor.Secondary}
        tooltip={t("ram:UnknownStatus")}
        size={BadgeSize.Sm}
      />
    );
  }

  return <IconBadge icon={config.icon} color={config.color} tooltip={t(config.tooltipKey)} size={BadgeSize.Sm} />;
}
